export default function frameDebounce(fn, finalRun) {
  let running = false;
  let lastCall;
  return (...args) => {
    requestAnimationFrame(() => {
      if (!running && lastCall) {
        lastCall();
      }
      running = false;
    });
    if (!running) {
      running = true;
      return fn(...args);
    } else if (finalRun) {
      lastCall = () => fn(...args);
    }
  };
}
